import React, { useCallback } from "react";
import PropTypes from "prop-types";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import classnames from "classnames";
import Str from "shared/components/Str";
import BoostBolt from "shared/components/BoostBolt";
import Overlay from "shared/components/FullscreenOverlay";
import ConnectionAvatars from "shared/components/ConnectionAvatars";
import GlobalMessaging from "features/global_messaging";

import "./App.scss";

const stopClick = (e) => e.stopPropagation();

const ConnectionModal = ({
	show,
	isViaBoost,
	onClose,
	myThumb,
	theirThumb,
	theirUsername,
	theirUserId,
	globalMessagingParams,
}) => {
	const onSayHello = useCallback((e) => {
		e.preventDefault();

		GlobalMessaging.openConversation(
			theirUserId,
			globalMessagingParams,
		);

		// Close this modal.
		onClose();
	}, [onClose, theirUserId, globalMessagingParams]);

	if (!show) {
		return null;
	}

	const containerClass = classnames({
		"connectionModal": true,
		"connectionModal--viaBoost": isViaBoost,
	});

	return (
		<CSSTransitionGroup
			transitionName="connectionModal"
			transitionAppear={true}
			transitionAppearTimeout={300}
			transitionEnterTimeout={300}
			transitionLeaveTimeout={150}
		>
			<div className="OkModal OkModal--scrollingoverlay">
				<Overlay onClick={onClose}>
					<div className={containerClass} onClick={stopClick} role="presentation">
						<div className="connectionModal-header">
							<div className="connectionModal-header-title">
								<Str>They like you back!</Str>
							</div>

							{!!isViaBoost &&
								<div className="connectionModal-header-subtitle">
									<BoostBolt />
									{" "}
									<Str>via Boost</Str>
								</div>
							}
							<span
								className="connectionModal-header-close"
								onClick={onClose}
								role="button"
								tabIndex={-1}
							>
								<span className="icon i-close" />
							</span>
						</div>

						<div className="connectionModal-thumbs">
							<ConnectionAvatars
								theirThumb={theirThumb}
								theirUsername={theirUsername}
								myThumb={myThumb}
							/>
						</div>

						<div className="connectionModal-description">
							<Str>You both like each other. Say something nice.</Str>
						</div>

						<div className="connectionModal-buttons">
							<button
								className="connectionModal-buttons-button connectionModal-buttons-button--cancel"
								onClick={onClose}
							>
								<Str>No, thanks</Str>
							</button>
							<button
								className="connectionModal-buttons-button connectionModal-buttons-button--confirm"
								onClick={onSayHello}
							>
								<Str>Say hello</Str>
							</button>
						</div>
					</div>
				</Overlay>
			</div>
		</CSSTransitionGroup>
	);
};

ConnectionModal.propTypes = {
	show: PropTypes.bool.isRequired,
	isViaBoost: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	myThumb: PropTypes.string.isRequired,
	theirThumb: PropTypes.string.isRequired,
	theirUserId: PropTypes.string.isRequired,
	theirUsername: PropTypes.string.isRequired,
	globalMessagingParams: PropTypes.object,
};

ConnectionModal.defaultProps = {
	isViaBoost: false,
};

export default ConnectionModal;



// WEBPACK FOOTER //
// ./src/shared/components/ConnectionModal/App.jsx